const customerFields = [
    'firstname', 'lastname', 'given_name', 'surname',
    'email', 'phone', 'mobile_number',
    'address1', 'address', 'street_name', 'street_number', 'zip', 'city',
    'country_code'
];
function parseJson(value) {
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    }
    catch {
        return null;
    }
}
function decodeScannerJson(input) {
    const direct = parseJson(input);
    if (direct) {
        return direct;
    }
    try {
        const bytes = Uint8Array.from(atob(input.replace(/\s/g, '')), character => character.charCodeAt(0));
        return parseJson(new TextDecoder().decode(bytes));
    }
    catch {
        return null;
    }
}
function normalizeCardNumber(value) {
    const card = String(value ?? '');
    const virtualCard = card.match(/v\[([^\]]+)\]/i);
    const normalized = virtualCard ? virtualCard[1].replace(/\D/g, '') : card.replace(/\s/g, '');
    return /^\d{13,16}$/.test(normalized) ? normalized : null;
}
function normalizeSwedishIdentityNumber(value) {
    const normalized = value.replace(/[\s-]/g, '');
    const short = /^(19|20)\d{10}$/.test(normalized) ? normalized.slice(2) : normalized;
    if (!/^\d{10}$/.test(short)) {
        return null;
    }
    const month = Number(short.slice(2, 4));
    const encodedDay = Number(short.slice(4, 6));
    const day = encodedDay >= 61 && encodedDay <= 91 ? encodedDay - 60 : encodedDay;
    if (month < 1 || month > 12 || day < 1 || day > 31) {
        return null;
    }
    const checksum = [...short].reduce((sum, character, index) => {
        const product = Number(character) * (index % 2 === 0 ? 2 : 1);
        return sum + (product > 9 ? product - 9 : product);
    }, 0);
    return checksum % 10 === 0 ? normalized : null;
}
export function normalizeScannableScrInput(input) {
    const trimmed = input.trim();
    const cardNumber = trimmed.replace(/[\s-]/g, '');
    if (!cardNumber.startsWith('00') && /^\d{13,16}$/.test(cardNumber)) {
        return cardNumber;
    }
    const identityNumber = normalizeSwedishIdentityNumber(trimmed);
    if (identityNumber) {
        return identityNumber;
    }
    const data = decodeScannerJson(trimmed);
    if (!data) {
        return null;
    }
    const hasCard = normalizeCardNumber(data.card_number) !== null;
    const hasCustomer = customerFields.some(field => Boolean(data[field]));
    return hasCard || hasCustomer ? trimmed : null;
}
